import { createReducer, on } from '@ngrx/store';
import { UiState, initialUiState } from './ui.state';
import { setPortalMode, setUserIdle } from './ui.actions';

export const uiReducer = createReducer(
  initialUiState,
  on(
    setUserIdle,
    (state, { isUserIdle }): UiState => ({
      ...state,
      isUserIdle: isUserIdle,
    })
  ),
  on(
    setPortalMode,
    (state, { portalMode }): UiState => ({
      ...state,
      portalMode,
    })
  )
);
